export const markers = [
  {
    id: 1,
    city: "Dubai",
    country: "UNITED ARAB EMIRATES",
    address: "UNIT 201, SECOND FLOOR - AL MASS TOWER, JUMEIRAH LAKE TOWERS",
    olgcs: "1,149",
    vault: "FERRARI LOGISTICS DMCC",
    valueOlgcs: "2,255,670.84",
    color: "red",
    coordinates: [25.2048, 55.2708],
    value: 80,
  },
  {
    id: 2,
    city: "Singapore",
    country: "Singapore",
    vault: "-",
    address: "-",
    olgcs: "-",
    valueOlgcs: "-",
    color: "blue",
    coordinates: [1.3521, 103.8198],
    value: 80,
  },
  {
    id: 3,
    city: "Hong Kong",
    country: "Hong Kong",
    address: "-",
    olgcs: "-",
    vault: "-",
    valueOlgcs: "-",
    color: "orange",
    coordinates: [22.3193, 114.1694],
    value: 75,
  },
  {
    id: 4,
    city: "Zurich",
    country: "SWITZERLAND",
    address: "-",
    olgcs: "-",
    vault: "-",
    valueOlgcs: "-",
    color: "gold",
    coordinates: [47.3769, 8.5417],
    value: 135,
  },
  {
    id: 5,
    city: "London",
    country: "United Kingdom",
    address: "-",
    olgcs: "-",
    vault: "-",
    valueOlgcs: "-",
    color: "green",
    coordinates: [51.5074, 0.1278],
    value: 80,
  },
];
